import React, { useEffect, useState } from "react";
import useDebounce from "../useDebounce/useDebounce";
import apiHelper from "../ApiHelpar/apiHelper";

import moment from "moment";
import {
  BLOGGER,
  DI_ADMIN,
  ROLE_ADMIN,
  ROLE_LAB,
  ROLE_USER,
  ROLEDOCTOR,
  SUPER_ADNIM,
  USER_ROLE,
} from "../../Constant";
import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";
import { GET_DATA_BYNAME_MOBILE } from "../visitConstant/ApiConstant";
import DrSearchDropDown from "../BranchSearchDropDown/DrSearchDropDown";
import BranchSearchDropdown from "../BranchSearchDropDown/BranchSearchDropDown";
import {
  AdditionalDetailsSection,
  CredentialsSection,
  DoctorTypeSection,
  GenderAgeSection,
  PatientBasicInfo,
  PatientContactInfo,
} from "./PatientBasicInfo";

const DoctorForm = ({
  user,
  handleChange,
  saveUser,
  onSelect,
  inputValue,
  setInputValue,
  setInputMobailValue,
  currentDate,
  setCurrentDate,
  // role = ROLE_USER,

  hospitalId,
  BaranchId,
  Role,
}) => {
  // State management
  const [loading, setLoading] = useState(false);
  const [nameOptions, setNameOptions] = useState([]);
  const [mobileOptions, setMobileOptions] = useState([]);
  const [nameInput, setNameInput] = useState("");
  const [mobileInput, setMobileInput] = useState("");
  const [dob, setDOB] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedGender, setSelectedGender] = useState(
    user.customerId?.gender || "M"
  );
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [opdLength, setOpdLength] = useState(4);

  // Debounced values
  const debouncedNameInput = useDebounce(nameInput, 500);
  const debouncedMobileInput = useDebounce(mobileInput, 700);

  // Load initial settings
  useEffect(() => {
    const userRole = localStorage.getItem(USER_ROLE);
    const opdCount = localStorage.getItem("opd_count");
    const validOpdCount =
      opdCount !== null && !isNaN(opdCount) ? Number(opdCount) : 4;

    setOpdLength(validOpdCount);
    setIsSuperAdmin(userRole?.includes(SUPER_ADNIM));

    if (user.customerId?.name || user.customerId?.mobileNo) {
      setMobileInput(user.customerId?.mobileNo || "");
      setNameInput(user.customerId?.name || "");
      setSelectedGender(user.customerId?.gender || "M");
    }
  }, [user.customerId?.name, user.customerId?.mobileNo]);

  // API fetch handler
  const fetchData = async (searchValue, setOptionsCallback) => {
    setLoading(true);
    try {
      const response = await apiHelper(GET_DATA_BYNAME_MOBILE, searchValue);

      if (
        response?.respData?.respMsg &&
        Array.isArray(response.respData.respMsg)
      ) {
        setOptionsCallback(
          response.respData.respMsg.length > 0 ? response.respData.respMsg : []
        );
      } else {
        console.error("API Response is missing the expected structure");
        setOptionsCallback([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOptionsCallback([]);
    } finally {
      setLoading(false);
    }
  };

  // Effect to handle name search
  useEffect(() => {
    if (debouncedNameInput?.trim() !== "") {
      setInputValue(debouncedNameInput);
      fetchData({ name: debouncedNameInput }, setNameOptions);
    }
  }, [debouncedNameInput]);

  // Effect to handle mobile search
  useEffect(() => {
    if (debouncedMobileInput?.trim() !== "") {
      setInputMobailValue(debouncedMobileInput);
      fetchData({ mobileNo: debouncedMobileInput }, setMobileOptions);
    }
  }, [debouncedMobileInput]);

  // Handle adding new items to form
  const handleAddNewItem = (fieldName, value) => {
    handleChange({
      target: {
        name: fieldName,
        value: value,
      },
    });
  };

  // Update user form when name input changes
  useEffect(() => {
    handleChange({
      target: {
        name: "customerId.name",
        value: nameInput,
      },
    });
  }, [nameInput]);

  // Update user form when mobile input changes
  useEffect(() => {
    handleChange({
      target: {
        name: "customerId.mobileNo",
        value: mobileInput,
      },
    });
  }, [mobileInput]);

  // Handle gender change
  const handleGenderChange = (event) => {
    const value = event.target.value;
    setSelectedGender(value);

    let salutation = "";
    if (value === "M") {
      salutation = "Mr";
    } else if (value === "F") {
      salutation = "Mrs";
    }

    handleChange({
      target: {
        name: "customerId.salutation",
        value: salutation,
      },
    });
  };

  // Calculate DOB from age
  useEffect(() => {
    if (user.customerId?.age) {
      const ageUnit = user.customerId.ageUnit || "years";
      const dobDate = moment()
        .subtract(user.customerId.age, ageUnit)
        .format("YYYY-MM-DD");

      setDOB(dobDate);
      handleChange({
        target: {
          name: "customerId.dob",
          value: dobDate,
        },
      });
    } else {
      setDOB("");
    }
  }, [user?.customerId?.age, user?.customerId?.ageUnit]);

  useEffect(() => {
    if (dob) {
      handleChange({
        target: {
          name: "customerId.dob",
          value: dob,
        },
      });
    } else {
      setDOB("");
    }
  }, [dob]);

  // Handle branch selection
  const handleBranchSelection = (branchId) => {
    handleChange({
      target: {
        name: "customerId.branchId",
        value: branchId.id,
      },
    });
  };

  // Form submission handler
  const handleSubmit = (e, isExisting) => {
    e.preventDefault();

    // Update user data before submission
    user.customerId.customerDetails.newEntry = showMoreDetails;
    user.customerId.gender = selectedGender;

    // Save the user
    saveUser(isExisting);

    // Clear input fields
    setNameInput("");
    setMobileInput("");
  };

  return (
    <div className="container py-4">
      <form>
        {/* <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold">Add New Patient</h3>
          {isSuperAdmin && (
            <input
              type="date"
              name="currentDate"
              onChange={(e) => setCurrentDate(e.target?.value)}
              value={currentDate}
              className="form-control"
              style={{ maxWidth: "200px" }}
            />
          )}
        </div> */}

        {/* Form sections */}
        <PatientBasicInfo
          user={user}
          handleChange={handleChange}
          onSelect={onSelect}
          loading={loading}
          nameOptions={nameOptions}
          setNameInput={setNameInput}
          nameInput={nameInput}
          mobileOptions={mobileOptions}
          setMobileInput={setMobileInput}
          mobileInput={mobileInput}
          handleAddNewItem={handleAddNewItem}
        />

        <GenderAgeSection
          user={user}
          handleChange={handleChange}
          selectedGender={selectedGender}
          handleGenderChange={handleGenderChange}
          dob={dob}
          setDOB={setDOB}
        />

        <DoctorTypeSection user={user} handleChange={handleChange} />

        <CredentialsSection
          user={user}
          handleChange={handleChange}
          handleBranchSelection={handleBranchSelection}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          hospitalId={hospitalId}
          BaranchId={BaranchId}
          Role={Role}
        />

        <PatientContactInfo
          user={user}
          handleChange={handleChange}
          role={""}
          constants={{
            ROLE_USER,
            SUPER_ADNIM,
            ROLE_ADMIN,
            ROLEDOCTOR,
            BLOGGER,
            ROLE_LAB,
            DI_ADMIN,
          }}
        />

        {/* Toggle Additional Details */}
        <div className="mb-4 text-center">
          <button
            type="button"
            className="btn btn-link text-decoration-none"
            onClick={() => setShowMoreDetails(!showMoreDetails)}
          >
            {showMoreDetails ? "Hide additional details" : "Add more details"}
          </button>
        </div>

        {/* Patient action buttons - new/existing */}
        {user.customerId?.name && (
          <div className="card mb-4 border-0 bg-light">
            <div className="card-body d-flex flex-wrap justify-content-center align-items-center gap-3">
              <p className="card-title mb-0 text-center fw-semibold">
                Are you updating an
              </p>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={(e) => handleSubmit(e, true)}
              >
                Existing Patient
              </button>
              <p className="card-text mb-0 text-center fw-semibold">
                Or creating a
              </p>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={(e) => handleSubmit(e, true)}
              >
                New Patient
              </button>
            </div>
          </div>
        )}

        {/* Additional details section */}
        {showMoreDetails && (
          <AdditionalDetailsSection
            user={user}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        )}
      </form>
    </div>
  );
};

export default DoctorForm;
